import { Box, Button, IconButton, paletteColors, Typography } from '@evaneos/b2b-ui';
import CloseIcon from '@evaneos/b2b-ui/icons/Close';
import RadioButtonCheckedIcon from '@evaneos/b2b-ui/icons/RadioButtonChecked';
import { useIntl } from 'react-intl';

import { SlideAndFade } from '../../../../../shared/components/Animation/SlideAndFade';

type RecordingInformationProps = {
    showRecordConfirmModal: boolean;
    onCloseRecordingModal: () => void;
    onConfirmRecording: () => void;
};

export const RecordingInformationModal = ({
    showRecordConfirmModal,
    onCloseRecordingModal,
    onConfirmRecording,
}: RecordingInformationProps) => {
    const { formatMessage } = useIntl();

    return (
        <Box
            sx={{
                position: 'absolute',
                bottom: '100%',
                left: 0,
                right: 0,
                mb: 1,
            }}
        >
            <SlideAndFade
                open={showRecordConfirmModal}
                direction="up"
                sx={{
                    borderRadius: '8px',
                    backgroundColor: paletteColors.green[700],
                    p: 2,
                    boxShadow: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
                        <Typography color="textContrast" variant="h4" flex="1">
                            {formatMessage({
                                id: 'phoning.recording_modal.title',
                            })}
                        </Typography>

                        <IconButton
                            onClick={onCloseRecordingModal}
                            size="small"
                            aria-label={formatMessage({
                                id: 'experiment.better_business.phoning.consent_modal_cancel',
                            })}
                        >
                            <CloseIcon fontSize="small" sx={{ color: paletteColors.neutral[0] }} />
                        </IconButton>
                    </Box>

                    <Typography color="textContrast" variant="body2">
                        {formatMessage({
                            id: 'phoning.recording_modal.description',
                        })}
                    </Typography>
                </Box>

                <Button
                    onClick={onConfirmRecording}
                    variant="contained"
                    color="contrasted"
                    size="medium"
                    startIcon={
                        <RadioButtonCheckedIcon
                            fontSize="small"
                            sx={{ color: paletteColors.red[600] }}
                        />
                    }
                    sx={{
                        color: paletteColors.neutral[900],
                    }}
                >
                    {formatMessage({
                        id: 'phoning.recording_modal.start_recording',
                    })}
                </Button>
            </SlideAndFade>
        </Box>
    );
};
